/* eslint-disable react/prop-types */
import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styles from './TabbedWorkspace.module.css';
import {Tabs, Tab, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';
import {pxToRem, responsiveFontSizes} from '../../utils/getFontValue';
import { DARK_MODE } from '../../constants';

const Panel = ({children, value, index}) => {
	if (index !== value) return <div style={{display: 'none'}} />;
	return <>{children}</>;
};

const Count = ({tab, currentTab, index}) => {
	return (
		<Typography
			sx={{
        color: currentTab === index ? '#e6e6e6' : tab.color,
        backgroundColor: currentTab === index && tab.color,
				padding: '0 .7rem',
        marginLeft: 1,
				borderRadius: 40,
        fontWeight: 600,
				fontSize: pxToRem(14),
				...responsiveFontSizes({sm: 14, md: 16, lg: 18}),
			}}
		>
			{tab.count}
		</Typography>
	);
};

const CssTabs = styled(Tabs)(({theme}) => ({
	height: '3rem',
	minHeight: '3rem',
	margin: 8,
	'& .MuiTabs-indicator': {
		display: 'none',
	},
	[theme.breakpoints.only('lg')]: {
		height: '4rem',
		minHeight: '4rem',
	},
}));

const CssTab = styled(Tab)(({theme, tabColor}) => ({
	height: '3rem',
	minHeight: '3rem',
	fontWeight: theme.typography.fontWeightBold,
	fontSize: pxToRem(12),
	...responsiveFontSizes({sm: 12, md: 14, lg: 16}),
	letterSpacing: '1px',
	padding: '0 1rem',
	marginLeft: 8,
	borderRadius: 4,
  color: '#e6e6e6',
	backgroundColor: theme.palette.mode === DARK_MODE ? 'black' : 'white',
	'&:first-child': {
		marginLeft: 0,
	},
  '&.Mui-selected': {
    color: tabColor
  },
  [theme.breakpoints.only('lg')]: {
		height: '4rem',
		minHeight: '4rem',
	},
}));

const TabbedWorkspace = ({tabs, defaultTab = 0}) => {
	const [tabVal, setTabVal] = useState(defaultTab);
	const handleTabChange = value => {
		setTabVal(value);
	};

	return (
		<div className={styles.workspace}>
			<div className={styles.tabBar}>
				<CssTabs value={tabVal} onChange={(e, value) => handleTabChange(value)}>
					{tabs.map((tab, index) => (
						<CssTab
              tabColor={tab.color}
							label={tab.label}
							disabled={tab.disabled}
							icon={<Count tab={tab} currentTab={tabVal} index={index} />}
							iconPosition='end'
						/>
					))}
				</CssTabs>
			</div>
			{tabs.map((tab, index) => (
				<Panel value={tabVal} index={index}>
					<tab.component {...tab.props} />
				</Panel>
			))}
		</div>
	);
};

TabbedWorkspace.propTypes = {
	tabs: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			component: PropTypes.node.isRequired,
			props: PropTypes.object,
		}),
	).isRequired,
};

Panel.propTypes = {
	children: PropTypes.node.isRequired,
	value: PropTypes.number.isRequired,
	index: PropTypes.number,
};

export default TabbedWorkspace;
